















import Campaign from "@/models/campaign";
import CampaignsAPI from "@/services/campaigns";
import { CampaignModule } from "@/store/campaign";
import { LayoutModule } from "@/store/layout";
import { cloneDeep } from "lodash";
import { Component, Vue } from "vue-property-decorator";
import CampaignForm from "./Components/CampaignForm.vue";

@Component({
  components: { CampaignForm },
})
export default class EditCampaign extends Vue {
  campaign: Campaign | null = null;
  loading = true;
  saveButton = true;
  statusChange = false;

  created(): void {
    if (this.$route.params.id) this.getCampaign();
  }

  onStatusChange(): void {
    this.saveButton = true;
    this.statusChange = true;
  }

  async getCampaign(): Promise<void> {
    this.loading = true;

    try {
      this.campaign = await CampaignsAPI.get(this.$route.params.id);
      this.loading = false;
      CampaignModule.setCurrentCampaign(this.campaign);
    } catch (e) {
      console.log(e);
    }
  }

  async save(campaign: Campaign): Promise<void> {
    try {
      const payload = cloneDeep(campaign);
      payload.avoid_conflicts = true;

      this.statusChange ? await CampaignsAPI.changeStatus(campaign) : null;
      await CampaignsAPI.update(payload);

      LayoutModule.setAlerts({
        text: this.$t("campaigns.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
  }
}
